export default "__VITE_ASSET__Bylm$JMS__"